import React, { createContext, useState } from 'react';

export const DataContext = createContext();

export const DataProvider = ({children}) => {
	const [fecha, setFecha] = useState(null)
	const [hora, setHora] = useState(null)
	const [nombre, setNombre] = useState(null)
	const [barbero, setBarbero] = useState(null)
	const [servicio, setServicio] = useState(null)
	const [celular, setCelular] = useState(null)
	const [email, setEmail] = useState(null)
	const [timesToCancel, setTimesToCancel] = useState(null)
	const [dateToCancel, setDatesToCancel] = useState(null)
	const [fechaInicio, setFechaInicio] = useState(null)
	const [fechaFinal, setFechaFinal] = useState(null)
  	const [dataEstadisticas, setDataEstadisticas] = useState(null);

	return (
		<DataContext.Provider value={{
			fecha,
			setFecha,
			hora,
			setHora,
			nombre,
			setNombre,
			barbero,
			setBarbero,
			servicio,
			setServicio,
			celular,
			setCelular,
			email,
			setEmail,
			timesToCancel,
			setTimesToCancel,
			dateToCancel,
			setDatesToCancel,
			fechaInicio,
			setFechaInicio,
			fechaFinal,
			setFechaFinal,
			dataEstadisticas,
			setDataEstadisticas
		}}>
			{ children }
		</DataContext.Provider>
	)
}
